// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.

const shadows = {
 "overlay": "0px 8px 32px rgba(0, 0, 0, 0.03), 0px 4px 16px rgba(0, 0, 0, 0.03), 0px 2px 8px rgba(0, 0, 0, 0.03), 0px 1px 4px rgba(0, 0, 0, 0.03)",
 "pressed": "0px 1px 2px rgba(0, 0, 0, 0.03), 0px 2px 4px rgba(0, 0, 0, 0.03), 0px 4px 8px rgba(0, 0, 0, 0.03), 0px 8px 16px rgba(0, 0, 0, 0.03)",
 "raised": "0px 0px 1px rgba(0, 0, 0, 0.04), 0px 1px 2px rgba(0, 0, 0, 0.04), 0px 2px 4px rgba(0, 0, 0, 0.04), 0px 4px 8px rgba(0, 0, 0, 0.04)"
}

export default shadows;